const CANONICAL_PARAMS = {
  page: v => parseInt(v) == v && v >= -1,
}

const getCanonicalParams = url => {
  try {
    const { searchParams } = new URL(url)
    const paramsArray = [...searchParams]
    paramsArray.forEach(([key, value]) => {
      if (!CANONICAL_PARAMS[key] || !CANONICAL_PARAMS[key](value)) {
        searchParams.delete(key)
      }
    })
    return searchParams.toString()
  } catch (e) {
    return null
  }
}

export const robotsContent = ({ robotsMeta = ['all'] }) => robotsMeta.join(',').trim()

export const canonicalHref = ({ canonical, href }) => {
  const url = new URL(canonical || href)

  url.protocol = 'https:'
  url.search = getCanonicalParams(canonical) || getCanonicalParams(href)

  return url.toString()
}
